<template>
<section class="breakout-box bg-primary-400 px-4 py-7%">
    <div class="max-w-4xl mx-auto">
        <div class="grid" :class="image ? 'with-image' : 'no-image'">
            <SmoothLoader tag="h2" v-html="headline" class="font-headline text-3xl vt:text-4rem font-bold mb-6 text-primary-700 leading-tight"></SmoothLoader>
            <SmoothLoader class="prose text-lg text-gray-800" v-html="blurb"></SmoothLoader>
            <SmoothLoader v-if="image" class="img-container">
                <img :src="image.src" :alt="image.alt" class="rounded">
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>